// DialogCommon component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import ReactDom from 'react-dom'

import Dialog from '../../layout/dialog/dialog.jsx'
import Button from '../../common/button/button.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'
import SvgIcon from '../../common/svgicon/svgicon.jsx'

class DialogCommon extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: props.active,
      showAllContent: false
    }

    this._references = {
      mainContent: React.createRef(),
      innerContent: React.createRef(),
      innerContentWrap: React.createRef(),
      actionReadMore: React.createRef()
    }
  }

  static get propTypes () {
    return {
      title: PropTypes.string,
      message: PropTypes.string,
      className: PropTypes.string,
      onOk: PropTypes.func,
      onCancel: PropTypes.func,
      showClose: PropTypes.bool,
      showCancel: PropTypes.bool,
      active: PropTypes.bool,
      showLeftPanel: PropTypes.bool,
      type: PropTypes.oneOf(['normal', 'warning', 'error'])
    }
  }

  static get defaultProps () {
    return {
      title: '',
      message: '',
      className: '',
      onOk: null,
      onCancel: null,
      showClose: false,
      showCancel: false,
      active: false,
      showLeftPanel: false
    }
  }

  componentDidUpdate () {
    this._handleReadMore()
  }

  show () {
    this.setState({ active: true })
  }

  hide () {
    this.setState({ active: false })
  }

  render () {
    const {
      title,
      message,
      showClose,
      showCancel,
      type,
      showLeftPanel,
      className
    } = this.props
    const { active } = this.state

    const _className = classnames('dialog-common', {
      'dialog-common_warning': type === 'warning',
      'dialog-common_error': type === 'error',
      hasleftpannel: showLeftPanel
    })

    return (
      <Dialog
        active={active}
        type='large'
        onClose={this._onClickCancel.bind(this)}
        modal={false}
        canCloseOnEsc={false}
        className={classnames('dialog_scrollable', className)}
      >
        <div className={_className} ref={this._references.mainContent}>
          {showLeftPanel && <div className='leftpannel' />}
          <div className='innercontent'>
            <div className='commonheader'>
              <div className='title'>
                <span className='action-close'>
                  <SvgIcon name='alert' size='24' className='iconcont' />
                </span>
                <IntlMessage ident={title} />
              </div>
              {showClose ? (
                <IconButton
                  icon='popup-close'
                  className='modal'
                  canHover
                  onClick={this._onClickCancel.bind(this)}
                />
              ) : null}
            </div>
            <div className='commoncontent'>
              <div className='cont' ref={this._references.innerContent}>
                <div
                  className='contwrap'
                  ref={this._references.innerContentWrap}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: IntlUtil.convertMessage(message)
                    }}
                  />
                </div>
              </div>
              <div className='readmore' ref={this._references.actionReadMore}>
                <Button
                  className='button_save button_view preview readmorebtn'
                  title='common.list.readMore'
                  canHover={false}
                  type='button'
                  onClick={this._onShowReadMore.bind(this)}
                />
              </div>
            </div>
            <div className='commonfooter'>
              <Button
                className='button_save button_view preview agree'
                title='common.list.agree'
                canHover={false}
                type='button'
                onClick={this._onClickOk.bind(this)}
              />
              {showCancel && (
                <Button
                  className='button_save button_view preview disagree'
                  title='common.list.disagree'
                  canHover={false}
                  type='button'
                  onClick={this._onClickCancel.bind(this)}
                />
              )}
              {type === 'warning' && showCancel && (
                <Button
                  className='button_save button_view preview submit'
                  title='common.list.submit'
                  canHover={false}
                  type='button'
                  onClick={this._onClickOk.bind(this)}
                />
              )}
            </div>
          </div>
        </div>
      </Dialog>
    )
  }

  /* Private Functions */
  _onClickOk (ev) {
    ev.preventDefault()

    if (this.props.onOk) {
      this.props.onOk(ev)
    }
  }

  _onClickCancel (ev) {
    if (ev) {
      ev.preventDefault()
    }

    this.hide()

    if (this.props.onCancel) {
      this.props.onCancel()
    }
  }

  _onShowReadMore () {
    this.setState({ showAllContent: true })
  }

  _handleReadMore () {
    if (
      this._references.innerContent.current &&
      this._references.mainContent.current &&
      this._references.innerContentWrap.current
    ) {
      let showReadMore = false
      const windowHeight = window.innerHeight

      // If read more enabled, Show all content
      if (this.state.showAllContent) {
        this._references.innerContent.current.style.maxHeight = 'none'
        this._references.innerContent.current.style.overflow = 'visible'
      } else {
        const gapsAll = 500
        const { height: innerContentHeight } = ReactDom.findDOMNode(
          this._references.innerContent.current
        ).getBoundingClientRect()
        const { height: innerContentWrapHeight } = ReactDom.findDOMNode(
          this._references.innerContentWrap.current
        ).getBoundingClientRect()
        const maxInnerContentHeight = windowHeight - gapsAll

        // Hide the extran content
        if (innerContentWrapHeight > innerContentHeight) {
          showReadMore = true
          this._references.innerContent.current.style.maxHeight = `${maxInnerContentHeight}px`
          this._references.innerContent.current.style.overflow = 'hidden'
        }
      }

      // Show read more button if content is larger
      if (this._references.actionReadMore.current) {
        this._references.actionReadMore.current.style.display = showReadMore
          ? 'block'
          : 'none'
      }

      const { height: outerContentHeight } = ReactDom.findDOMNode(
        this._references.mainContent.current
      ).getBoundingClientRect()
      if (windowHeight < outerContentHeight + 60) {
        this._references.mainContent.current.style.marginBottom = '30px'
      } else {
        this._references.mainContent.current.style.marginBottom = '0px'
      }
    }
  }
}

export default DialogCommon
